
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";

interface ReceivedAmountTrace {
  id: number;
  settleDate: string;
  requestSender: number;
  requestSenderName: string;
  requestTo: number;
  requestToName: string;
  amount: number;
  referenceNumber?: string;
  remarks?: string;
  responseDate: string;
}

interface Props {
  visible: boolean;
  onHide: () => void;
  userID: number;
  userName: string;
  startDate: string;
  endDate: string;
}

const ReceivedAmountTraceDatatable: React.FC<Props> = ({
  visible,
  onHide,
  userID,
  userName,
  startDate,
  endDate,
}) => {
  const [loading, setLoading] = useState(false);
  const [receivedData, setReceivedData] = useState<ReceivedAmountTrace[]>([]);
debugger
  useEffect(() => {
  if (!visible) return;

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await DeliveryCashService.GetReceivedCashTrace({
        userID,
        startDate,
        endDate,
      });
      setReceivedData(response || []);
    } catch (error) {
      console.error("Failed to fetch received amount trace:", error);
      setReceivedData([]);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [visible, userID, startDate, endDate]);

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB");
};
  return (
    <Dialog
      header={`Received Amount Details - ${userName}`}
      visible={visible}
      onHide={onHide}
      style={{ width: "70vw" }}
      modal
    >
      <DataTable value={receivedData}
       loading={loading}
       paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        {/* <Column field="id" header="ID" style={{ width: "5%" }} /> */}
        {/* <Column field="settleDate" header="Settle Date" /> */}
        
        <Column field="requestSenderName" header="Received From"/>
        {/* <Column field="requestToName" header="Receiver" /> */}
        <Column field="amount" header="Amount" />
        <Column field="responseDate" header="Received Date"   body={(rowData) => formatDate(rowData.responseDate)}/>
        {/* <Column field="referenceNumber" header="Reference #" />
        <Column field="remarks" header="Remarks" /> */}
      </DataTable>
    </Dialog>
  );
};

export default ReceivedAmountTraceDatatable;
